import React from 'react';
import { useHeaderContext } from '@/creditflowresearch/application/Header/HeaderContext';
import ResultsColumn from './ResultsColumn';

type TProps = Omit<React.ComponentProps<typeof ResultsColumn>, 'searchResult'>;

const ResultsColumnContainer = (props: TProps) => {
  const { searchResult } = useHeaderContext();

  return <ResultsColumn { ...props } searchResult={ searchResult } />;
};

export default ResultsColumnContainer;
